import React, { useContext } from 'react'
import classNames from 'classnames'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export function InteriorImage({ children }) {
  const {
    isDealerConfigurator,
    interiorImage
  } = useContext(ConfiguratorContext)

  if (!interiorImage?.interior_image_url) return children

  return (
    <div className={classNames('image-container', {
      'has-no-footer': isDealerConfigurator
    })}>
      <picture data-object-fit>
        {
          typeof interiorImage?.interior_image_url_srcset === 'object'
            ? Object.entries(interiorImage.interior_image_url_srcset).map(entry => (
              <source key={entry[0]} srcSet={entry[1]} media={'(max-width: ' + entry[0] + 'px)'} />
            ))
            : null
        }
        <img src={interiorImage.interior_image_url} data-object-fit='true' />
      </picture>
    </div>
  )
}
